import { Link } from 'react-router-dom';

const IntegrationsOverview = () => (
  <section className="min-w-0 max-w-xl bg-sand-50 p-4 ring-1 ring-ink-900/10 sm:p-8">
    <p className="text-[11px] uppercase tracking-[0.18em] text-saffron-600 sm:text-xs sm:tracking-[0.22em]">
      Connectors
    </p>
    <h2 className="mt-2 font-display text-xl font-light text-ink-900 sm:text-2xl">
      More integrations coming soon
    </h2>
    <p className="mt-2 text-sm leading-relaxed text-ink-700/80">
      Payments live under{' '}
      <Link to="/app/manage/payments" className="font-medium text-ink-900 underline">
        Manage → Payments
      </Link>
      . WhatsApp Business is under{' '}
      <Link to="/app/messages/whatsapp" className="font-medium text-ink-900 underline">
        Messages
      </Link>
      .
    </p>
  </section>
);

export default IntegrationsOverview;
